import styled from 'styled-components';

import {
  StyledContainer as LiveTrainsContainer,
  StyledDisruptionMessages,
  StyledTrains
} from 'pages/LiveTravelInformation/LiveTrainsInformation.styles';

export const StyledContainer = styled(LiveTrainsContainer)``;

export const StyledWarningDetails = styled(StyledDisruptionMessages)``;

export const StyledAffectedTrains = styled(StyledTrains)``;

export const StyledDateHeading = styled.h2`
  margin: 24px 0 16px;
`;
